<template>
  <div class="dialog-app-panel" :class="isShow ? 'dialog-show' : ''">
    <appPanel
      class="app-panel"
      :isExpand="isShow"
      :title="
        pageStates == 'add'
          ? '新增配置'
          : pageStates == 'edit'
          ? '编辑配置'
          : '配置详情'
      "
      @cancel="handleClosePanel"
    >
      <el-scrollbar style="height: 100%">
        <el-form
          :model="setForm"
          :inline="true"
          style="padding: 16px"
          ref="refSetForm"
          label-width="110px"
          :rules="rules"
        >
          <el-form-item label="预案名称 ：" prop="name">
            <span v-if="pageStates == 'view'">
              {{ setForm.name }}
            </span>
            <el-input
              v-else
              v-model="setForm.name"
              clearable
              :placeholder="$t('reserve.placeholder.preplanname')"
            ></el-input>
          </el-form-item>
          <el-form-item label="预案分类 ：" prop="alarmTypeList">
            <span v-if="pageStates == 'view'">
              {{ filterType(setForm.alarmTypeList).join(" | ") }}
            </span>
            <el-checkbox-group v-else v-model="setForm.alarmTypeList">
              <el-checkbox
                v-for="item in alarmTypeList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="预案步骤 ：" prop="checkStepList">
            <div v-if="pageStates == 'view'" style="margin-top: 10px">
              <el-timeline class="timeLine">
                <el-timeline-item
                  v-for="(step, index) in rightCheckedStep"
                  :key="index"
                  placement="top"
                  :timestamp="step | dic('SENU073006')"
                >
                </el-timeline-item>
              </el-timeline>
            </div>
            <stepTransfer
              v-else
              :value.sync="rightCheckedStep"
              :props="propStep"
              @deleteStep="deleteStep"
              @changeData="checkStep"
              @checkTemplate="checkTemplate"
              ref="refStepTransfer"
              type="step"
              :data="stepAll"
              :titles="[
                $t('reserve.title.steplist'),
                $t('reserve.title.checkstep'),
              ]"
            ></stepTransfer>
          </el-form-item>
          <el-form-item label="备注 ：" prop="desc">
            <span v-if="pageStates == 'view'" class="text">
              {{ setForm.desc }}
            </span>
            <el-input
              v-else
              v-model="setForm.desc"
              clearable
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              show-word-limit
              maxlength="200"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div slot="footer">
        <el-button @click="handleClosePanel" :loading="subLoading" type="info">
          {{ subLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button
          v-if="pageStates != 'view'"
          @click="handleSavePanel"
          :loading="subLoading"
          type="primary"
        >
          {{ subLoading ? "提交中" : "保存" }}
        </el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index";
import stepTransfer from "./step-transfer";
import { Dic } from "$utils";
import { api } from "../api";
export default {
  name: "information",
  components: { stepTransfer, appPanel },
  props: ["pageStates"],
  data() {
    return {
      subLoading: false,
      stepAll: [],
      checkStepList: [],
      propStep: {
        label: "label",
        key: "value",
      },
      isShow: false,
      alarmTypeList: [],
      setForm: {
        level: "4",
        class: "",
        type: "2",
        alarmTypeList: [],
        name: "",
        desc: "",
        sourceTerminalId: "",
        checkStepList: [],
      },
      reserveClass: [],
      reserveLevel: [],
      emergencyPlanName: "",
      planStepList: [],
      rightCheckedTree: [],
      rightCheckedStep: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t("reserve.placeholder.preplanname"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "blur",
          },
        ],
        alarmTypeList: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change",
          },
        ],
        checkStepList: [
          {
            required: true,
            message: "请选择动作",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.initDic();
  },
  mounted() {},
  methods: {
    filterType(data) {
      let value = [];
      data.forEach((el) => {
        this.alarmTypeList.forEach((item) => {
          if (item.value == el) {
            value.push(item.label);
          }
        });
      });
      return value;
    },
    filterStep(data) {
      let value = [];
      data.forEach((el) => {
        this.stepAll.forEach((item) => {
          if (item.value == el) {
            value.push(item.label);
          }
        });
      });
      return value;
    },
    // 选择终端源头
    checkTemplate(val) {
      this.setForm.sourceTerminalId = val.thirdDeviceId;
    },
    // 预案动作选择回调
    checkStep(val) {
      console.log(val);
      if (val.length) {
        this.$refs.refSetForm.clearValidate(["checkStepList"]);
      }
      if (
        !val.some((el) => {
          return el.value == 6;
        })
      ) {
        this.$refs.refStepTransfer.checkRadioData2 = null;
        this.setForm.sourceTerminalId = "";
      }
      this.checkStepList = val;
      this.setForm.checkStepList = [...val];
    },
    handleShowPanel(row) {
      console.log("row", row);
      if (this.pageStates != "add") {
        this.setForm.name = row.emergencyPlanName;
        this.setForm.class = parseInt(row.type);
        this.setForm.level = parseInt(row.level);
        this.setForm.desc = row.desc;
        this.setForm.status = row.status;
        this.emergencyPlanCode = row.emergencyPlanCode;
        this.$nextTick(() => {
          row.subSystemList.forEach((value, index) => {
            this.setForm.alarmTypeList.push(parseInt(value));
          });
          this.rightCheckedStep = row.stepList.map((item) => parseInt(item));
          if (row.sourceTerminalId && this.pageStates != "view") {
            this.setForm.sourceTerminalId = row.sourceTerminalId;
            this.$refs.refStepTransfer.checkRadioData2 = {
              sourceTerminalId: row.sourceTerminalId,
              sourceTerminalName: row.deviceName,
            };
          }
        });

        // console.log(this.setForm);
      }
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    initDic() {
      this.alarmTypeList = [];
      this.planStepList = [];
      Dic.find("SENU073001").forEach((item) => {
        this.reserveClass.push(item);
      });
      Dic.find("SENU073002").forEach((item) => {
        this.reserveLevel.push(item);
      });
      Dic.find("SENU073005").forEach((item) => {
        this.alarmTypeList.push(item);
      });
      Dic.find("SENU073006").forEach((item) => {
        this.planStepList.push(item);
        this.stepAll = this.planStepList;
      });
    },
    initStep() {
      const params = {
        emergencyPlanName: this.setForm.name,
        type: this.setForm.class, //2
        level: this.setForm.level, //4
        pageNum: 1,
        pageSize: 10,
        status: 0,
        alarmTypeList: this.setForm.alarmTypeList,
      };
      console.log(this.setForm);
      this.$fetch(api.reserve.queryEmergencyPlanList, params)
        .then((response) => {
          if (response.success) {
            this.rightCheckedStep = response.returnObj.list.stepList;
            console.log(this.stepAll, "*****stepAll****");
          } else {
            this.$message({
              type: "warning",
              message: response.msgContent,
            });
          }
        })
        .catch(() => {});
    },

    deleteStep(id) {
      this.$fetch(api.reserve.deletePlanStep, { planStepId: id })
        .then((response) => {
          if (response.success) {
            this.$message({
              message: response.msgContent,
              type: "success",
            });
            this.initStep();
          } else {
            this.$message({
              type: "warning",
              message: response.msgContent,
            });
          }
        })
        .catch(() => {});
    },
    handleClosePanel() {
      this.checkStepList = [];
      this.rightCheckedStep = [];
      this.isShow = false;
      this.$nextTick(() => {
        this.$refs.refSetForm.resetFields();
      });
    },
    handleSavePanel() {
      this.$refs["refSetForm"].validate((valid) => {
        if (valid) {
          let planStepList = [];
          // 步骤
          if (this.checkStepList.length > 0) {
            this.checkStepList.forEach((item) => {
              planStepList.push(item.value);
            });
          }
          // 分类
          if (this.setForm.alarmType && this.setForm.alarmType.length === 0) {
            this.$message({
              message: this.$t("reserve.message.alarmType"),
              type: "error",
            });
            return;
          }
          // 终端源
          if (planStepList.indexOf(6) != -1 && !this.setForm.sourceTerminalId) {
            this.$message({
              message: "请配置广播终端",
              type: "warning",
            });
            return;
          }
          this.subLoading = true;
          let params = {
            emergencyPlanName: this.setForm.name,
            type: 2 || this.setForm.class,
            level: 4 || this.setForm.level,
            subSystemList: this.setForm.alarmTypeList, //分类
            stepList: planStepList, //步骤
            sourceTerminalId: this.setForm.sourceTerminalId, //终端源
            desc: this.setForm.desc,
            status: this.setForm.status,
          };
          let url = api.reserve.addEmergencyPlan;
          if (this.pageStates === "edit") {
            params.emergencyPlanCode = this.emergencyPlanCode;
            url = api.reserve.updateEmergencyPlan;
          }
          console.log("params", params);
          this.$fetch(url, params).then((response) => {
            this.subLoading = false;
            if (response.success) {
              this.$message({
                message: response.msgContent,
                type: "success",
              });
              this.handleClosePanel();
              this.$emit("updateTable");
            } else {
              this.$message({
                type: "error",
                message: response.msgContent,
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.timeLine {
  :deep .el-timeline-item__timestamp {
    //color: #ffffff;
  }

  :deep .el-timeline-item__content {
    // color: #ffffff;

    p {
      margin: 12px 0;
    }

    .action {
      position: absolute;
      top: -12px;
      left: 35%;
      background: #407aee;
      color: #fff;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }

  :deep .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
}

.el-form-item {
  display: flex;
  :deep .el-form-item__content {
    width: calc(100% - 100px);
  }
  :deep .el-upload--picture-card {
    width: 200px;
    height: 175px;
  }
  .el-input__inner {
    width: 100%;
  }
  .text {
    display: inline-block;
    width: 100%;
    word-break: break-all;
  }
}
</style>
